import React from "react";

import SectionStreamWrapper from "stream/containers/SectionStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";

import { SECTION, HEADER_LEVELS } from "config/constants";
import { HeaderContext } from "config/contexts";

export default function TopSectionStream(props) {
  return (
    <HeaderContext.Provider value={HEADER_LEVELS.TOP_STORIES_STREAM}>
      <SectionStreamWrapper {...props} slug={SECTION.TOP.slug}>
        {({ streamParams }) => {
          return <Stream {...streamParams} contentComponent={FullStoryCard} />;
        }}
      </SectionStreamWrapper>
    </HeaderContext.Provider>
  );
}
